<template>
  <v-app>
    <SSO v-if="currentUser === null"></SSO>
    <Main v-if="currentUser !== null"></Main>
  </v-app>
</template>

<script>
  import { mapState } from "vuex"
  import SSO from '@/components/SSO'
  import Main from '@/components/Main'

  export default {
    name: 'App',
    components: {
      SSO,
      Main,
    },
    data() {
      return {}
    },

    computed: {
      ...mapState([
        'currentUser',
      ]),
    },
  }
</script>

<style lang="scss">
  .home-link {
    text-decoration: none;
    color: #000;

    &:hover {
      text-decoration: underline;
    }
  }
</style>